import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { KeyRound, AlertCircle, Loader2 } from 'lucide-react';

export default function UstaGiris() {
  const navigate = useNavigate();
  const [kod, setKod] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  async function handleGiris(e) {
    e.preventDefault();
    if (kod.length < 4) return;
    setHata('');
    setYukleniyor(true);
    
    try {
      // Veritabanında kod alanı 'kod' mu yoksa 'girisKodu' mu kontrol edin.
      // Paylaştığın koda göre 'kod' üzerinden sorgu yapıyoruz.
      const q = query(
        collection(db, 'ustalar'), 
        where('kod', '==', kod.trim()), 
        where('aktif', '==', true)
      );
      
      const snap = await getDocs(q);

      if (snap.empty) {
        setHata('Geçersiz kod. Lütfen tekrar deneyin.');
      } else {
        const ustaData = { id: snap.docs[0].id, ...snap.docs[0].data() };
        
        // PWA'nın oturumu hatırlaması için localStorage kullanıyoruz
        localStorage.setItem('usta_oturum', JSON.stringify(ustaData));
        
        // Usta paneline yönlendir
        navigate('/usta/panel');
      }
    } catch (err) {
      setHata('Bağlantı hatası: ' + err.message);
    } finally {
      setYukleniyor(false);
    }
  }

  return (
    <div className="min-h-screen bg-stone-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="text-4xl font-bold tracking-[10px] text-white mb-1">AGE</div>
          <div className="text-[10px] tracking-[3px] uppercase text-stone-500">
            İzolasyon ve Çatı Sistemleri
          </div>
          <div className="mt-6 text-stone-500 text-sm font-medium tracking-widest uppercase">Usta Paneli</div>
        </div>

        <form onSubmit={handleGiris} className="space-y-4">
          <div>
            <label className="block text-[10px] text-stone-600 tracking-[0.2em] uppercase mb-3 ml-1">
              Giriş Kodunuz
            </label>
            <div className="relative">
              <KeyRound className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-700" size={18} />
              <input
                type="text"
                inputMode="numeric"
                value={kod}
                onChange={e => setKod(e.target.value.replace(/\D/g, '').slice(0, 6))}
                required
                maxLength={6}
                placeholder="••••••"
                className="w-full bg-stone-900/50 border border-stone-800 text-white pl-12 pr-4 py-4 rounded-2xl text-lg text-center tracking-[12px] focus:outline-none focus:border-emerald-500/50 transition-all placeholder-stone-800 shadow-inner"
              />
            </div>
          </div>

          {hata && (
            <div className="flex items-center gap-3 text-red-400 text-xs bg-red-400/5 border border-red-400/10 rounded-xl px-4 py-3 animate-pulse">
              <AlertCircle size={16} />
              {hata}
            </div>
          )}

          <button
            type="submit"
            disabled={yukleniyor || kod.length < 4}
            className="w-full bg-white text-stone-950 font-bold py-4 rounded-2xl text-sm tracking-widest uppercase hover:bg-stone-200 active:scale-[0.98] transition-all disabled:opacity-20 shadow-lg shadow-white/5"
          >
            {yukleniyor ? <Loader2 className="animate-spin mx-auto" size={20} /> : 'Sisteme Bağlan'}
          </button>
        </form>
        
        <p className="mt-8 text-center text-[10px] text-stone-700 tracking-widest uppercase">
          © 2024 AGE İzolasyon Saha Yönetimi
        </p>
      </div>
    </div>
  );
}